import CTAButton from '@/components/shared/CTAButton'

const ReferralProgramBody = () => {
  return (
    <div className="bg-white py-12 lg:py-16">
      <div className="container mx-auto max-w-6xl px-4">
        <h2 className="mb-4 text-left text-2xl font-black text-[#002020] sm:mb-6 sm:text-3xl">
          Get your friends up to{' '}
          <span className="font-raleway-numbers">around £829</span> per claim
          <sup>4</sup>, and you get rewarded…
        </h2>

        <p className="mb-6 text-left text-base text-[#002020] sm:mb-8 sm:text-lg">
          Have your friends ever had a vehicle using a finance agreement? They
          could be owed up to{' '}
          <span className="font-raleway-numbers">around £829</span> in
          compensation per claim<sup>4</sup>. Share your personalised link, and
          get rewarded for every successful claim they make.
        </p>

        <h2 className="mb-4 text-left text-2xl font-black text-[#002020] sm:mb-6 sm:text-3xl">
          The Chances are your friends may have had a car using a finance
          agreement between{' '}
          <span className="font-raleway-numbers">2007 - 2024</span>
        </h2>

        <p className="mb-6 text-left text-base text-[#002020] sm:mb-8 sm:text-lg">
          Millions of people were affected by widespread mis-selling of car
          finance agreements, often without knowing it. Could your friends and
          family be among them? Help by telling them about Claims1, and
          you&apos;ll get a{' '}
          <strong className="font-raleway-numbers">£10 reward</strong> for each
          successful compensation claim they make.
        </p>

        <h2 className="mb-4 text-left text-2xl font-black text-[#002020] sm:mb-6 sm:text-3xl">
          Claims1 has helped thousands of people to get compensation
        </h2>

        <p className="mb-6 text-left text-base text-[#002020] sm:mb-8 sm:text-lg">
          For more than a decade, we&apos;ve been helping people to understand
          their rights and claim compensation for mis-sold finance agreements.
          We provide a vital service on a{' '}
          <strong>
            No Win No Fee
            <sup style={{ fontSize: '0.7em', verticalAlign: 'super' }}>3</sup>
          </strong>{' '}
          basis to make it easy for people to get the compensation they deserve.
        </p>

        <div className="flex justify-center">
          <CTAButton text="SHARE YOUR CODE NOW" disabled={true} />
        </div>
      </div>
    </div>
  )
}

export default ReferralProgramBody
